import _extends from "@babel/runtime/helpers/esm/extends";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import CheckboxFieldPreviewNaked from '@sprinx/react-mui-fields/CheckboxFieldPreviewNaked';
import NumberFieldPreviewNaked from '@sprinx/react-mui-fields/NumberFieldPreviewNaked';
import TextFieldPreviewNaked from '@sprinx/react-mui-fields/TextFieldPreviewNaked';
import DateFieldPreviewNaked from '@sprinx/react-mui-fields/DateFieldPreviewNaked';
import isDate from 'lodash/fp/isDate';

function ProductParameterValue(_ref) {
  var parameter = _ref.parameter,
      rest = _objectWithoutProperties(_ref, ["parameter"]);

  var value = parameter.value;
  var t = useTranslate();

  if (typeof value === 'undefined' || value === null) {
    return null;
  }

  var ValueComponent;

  if (typeof value === 'boolean') {
    ValueComponent = CheckboxFieldPreviewNaked;
  } else if (typeof value === 'number') {
    ValueComponent = NumberFieldPreviewNaked;
  } else if (typeof value === 'string') {
    ValueComponent = TextFieldPreviewNaked;
  } else if (isDate(value)) {
    ValueComponent = DateFieldPreviewNaked;
  } else if (_typeof(value) === 'object') {
    ValueComponent = TextFieldPreviewNaked;
    value = t(value.label, {
      acceptString: true
    }) || value.value;
  } else {
    ValueComponent = TextFieldPreviewNaked;
  }

  return /*#__PURE__*/React.createElement(ValueComponent, _extends({
    value: value,
    size: "small",
    color: "textSecondary"
  }, rest));
}

ProductParameterValue.propTypes = {
  parameter: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.shape({
      label: PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      })),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    })])
  }).isRequired
}; // ProductParameterValue.defaultProps = {
//   parameter: undefined,
// };

export default ProductParameterValue;